var path = 'infrastructure/controllers/views/message-box-dialog.html';
var html = "<div class=modal-header> {{ options.caption }} </div> <div class=modal-body> <error-box error=isWorking.error></error-box> {{ options.message }} </div> <div class=modal-footer> <spin active=isWorking.busy style=position:relative;top:15px;left:15px></spin> <span ng-repeat=\"btn in options.buttons\"> <button class=btn ng-class=btn.cssClass ng-click=submit(btn.result)>{{ btn.label }}</button> </span> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/controllers/views/message-box-dialog.html
// module id = 8522317172616439
// module chunks = 1